import { ReportTypes } from "@/app/reports/utils/enums";
import httpManager from "@/app/shared/utils/httpManager";

export interface DownloadDto {
  entity: number | "";
  portfolio: number | "";
  date: string[];
}

class MessagingTickets {
  private baseUrl = `/reports/${ReportTypes.MessagingTickets}/download`;

  async download(downloadDto: DownloadDto) {
    const { entity, portfolio, date } = downloadDto;
    const startDate = `${date.at(0)} 00:00:00`;
    const endDate = `${date.at(1)} 23:59:59`;
    console.log(date,"date")
    const url = `${this.baseUrl}/?entity=${entity || ""}&portfolio=${portfolio || ""}&start_date=${startDate}&end_date=${endDate}`;

    const response = await httpManager.post(url, {}, { blob: true });

    return response;
  }
}

export const messagingTicketsService = new MessagingTickets();
